import { PreneedSalesSections } from "../sales/sale-steps";
import { StepperActionType } from "./enums";

/**
 * Stepper Status
 *
 * @export
 * @class {CanContinue}
 */
export class StepperStatus {

  constructor(
    public CurrentStep: PreneedSalesSections | PreneedSalesSections.None,
    public CanContinue: boolean | false,
    public CanGoBack: boolean | false,
    public ShowFooterNavigation: boolean | false
  ) {

  }
}

/**
 * For use on Stepper CanContinue Observable
 *
 * @export
 * @class {CanContinue}
 */
export class CanContinue {
  constructor(
    public CurrentStep: PreneedSalesSections | PreneedSalesSections.None,
    public CanContinue: boolean | false
  ) {

  }
}

/**
 * Stepper Action (Move Back and forward)
 *
 * @export
 * @class {StepperAction}
 */
export class StepperAction {
  constructor(
    public ActionType: StepperActionType | StepperActionType.None,
    public CurrentStep: PreneedSalesSections | PreneedSalesSections.None
  ) { }
}
